import { m } from 'framer-motion';
// @mui
import { styled } from '@mui/material/styles';
import { Box, Stack, Typography } from '@mui/material';
import { MotionContainer, varFade } from '../../components/animate';
import { varContainer } from '../../components/animate/variants';
import { HEADER } from '../../config';

// ----------------------------------------------------------------------

const RootStyle = styled(m.div)(({ theme }) => ({
  position: 'relative',
  height: '50vh',
  overflow: 'hidden',
  [theme.breakpoints.up('md')]: {
    top: HEADER.MAIN_DESKTOP_HEIGHT,
    left: 0,
    width: '100%',
    height: `calc(100vh - ${HEADER.MAIN_DESKTOP_HEIGHT}px)`,
    display: 'flex',
    position: 'fixed',
    alignItems: 'center',
  },
  [theme.breakpoints.down('md')]: {
    top: HEADER.MOBILE_HEIGHT,
    left: 0,
    width: '100%',
    height: '42vh',
    display: 'flex',
    position: 'fixed',
    alignItems: 'center',
  },
}));

const HeroOverlayStyle = styled(m.img)(({ theme }) => ({
  zIndex: 8,
  width: '100%',
  height: '100%',
  left: 0,
  objectFit: 'cover',
  position: 'absolute',
  objectPosition: 'left center',
  [theme.breakpoints.down('md')]: {
    objectPosition: 'left center',
  },
  [theme.breakpoints.down('sm')]: {
    objectPosition: '34% center',
  },
}));

const HeroOverlayTextStyle = styled(m.div)(({ theme }) => ({
  zIndex: 10,
  width: 'min(44%, 680px)',
  height: '100%',
  right: '6%',
  display: 'flex',
  position: 'absolute',
  alignItems: 'center',
  justifyContent: 'flex-start',
  padding: theme.spacing(2),
  [theme.breakpoints.down('lg')]: {
    width: '40%',
    right: '4%',
    alignItems: 'flex-end',
    paddingBottom: '7vh',
  },
  [theme.breakpoints.down('md')]: {
    width: '43%',
    height: '100%',
    right: '3%',
    padding: theme.spacing(1.5),
    paddingBottom: '4vh',
  },
  [theme.breakpoints.down('sm')]: {
    top: 14,
    bottom: 14,
    width: '40%',
    height: 'auto',
    right: 6,
    alignItems: 'center',
    justifyContent: 'center',
    padding: 0,
  },
}));

const HeroQuoatationStyleStart = styled(m.img)(({ theme }) => ({
  width: '55px',
  height: '39px',
  objectFit: 'contain',
  [theme.breakpoints.down('md')]: {
    width: '35px',
    height: '25px',
  },
  [theme.breakpoints.down('sm')]: {
    display: 'none',
  },
}));
const HeroQuoatationStyleEnd = styled(m.img)(({ theme }) => ({
  width: '55px',
  height: '39px',
  objectFit: 'contain',
  display: 'inline-block',
  verticalAlign: 'middle',
  [theme.breakpoints.down('md')]: {
    width: '35px',
    height: '25px',
  },
  [theme.breakpoints.down('sm')]: {
    width: '22px',
    height: '16px',
  },
}));

// ----------------------------------------------------------------------

export default function HomeHero() {
  return (
    <Box sx={{ height: { xs: `calc(42vh + ${HEADER.MOBILE_HEIGHT}px)`, md: '100vh' } }}>
      <MotionContainer>
        <RootStyle>
          <HeroOverlayStyle src="/assets/banners/banniere2.png" alt="banniere" variants={varFade().in} />
          <HeroOverlayTextStyle variants={varFade().in}>
            <Box
              component={m.div}
              variants={{ initial: {}, ...varContainer({ staggerIn: 0.5, delayIn: 1.5 }) }}
              sx={{
                width: '100%',
                borderRadius: { xs: 0.75, sm: 1 },
                p: { xs: 0.8, sm: 1.5, md: 2, lg: 2.5 },
                bgcolor: 'rgba(4, 36, 33, 0.68)',
                boxShadow: '0 16px 36px rgba(0,0,0,0.22)',
                backdropFilter: 'blur(2px)',
              }}
            >
              <Stack
                direction="row"
                component={m.div}
                variants={{ initial: {}, animate: { transition: { staggerChildren: 0.5, delayChildren: 0.5 } } }}
                sx={{ width: '100%', alignItems: 'flex-start' }}
              >
                <HeroQuoatationStyleStart
                  variants={varFade().inLeft}
                  src="/assets/banners/first.png"
                  alt="first"
                  sx={{ mr: { xs: 0, sm: 1, md: 2 }, flexShrink: 0 }}
                />
                <Typography
                  component={m.span}
                  display="block"
                  variant="h4"
                  fontSize={{ xs: 8.8, sm: 13, md: 18, lg: 25 }}
                  lineHeight={{ xs: 1.16, sm: 1.25, md: 1.35, lg: 1.38 }}
                  fontWeight={600}
                  color="#fff"
                  fontFamily="Poppins"
                  variants={varFade().inUp}
                  sx={{ opacity: 0.999, minWidth: 0, textShadow: '0 2px 8px rgba(0,0,0,0.35)' }}
                >
                  Nous sommes plus que jamais déterminés à faire du Togo une terre de prospérité et de sécurité pour les investisseurs. 

                  <HeroQuoatationStyleEnd
                    component={m.img}
                    variants={varFade().inUp}
                    src="/assets/banners/end.png"
                    alt="end"
                    sx={{ ml: { xs: 0.5, md: 1.5 } }}
                  />
                </Typography>
              </Stack>
              <Stack component={m.div} variants={varFade().inUp} ml={{ xs: 0, sm: 6, md: 9 }} pt={{ xs: 0.5, md: 3 }}>
                <Typography
                  component={m.span}
                  color="#fff"
                  fontFamily="Poppins"
                  fontWeight={900}
                  fontSize={{ xs: 8, sm: 10.5, md: 12.5, lg: 14 }}
                  sx={{ textShadow: '0 2px 8px rgba(0,0,0,0.35)' }}
                >
                  SEM Faure Essozimna GNASSINGBÉ,
                </Typography>
                <Typography
                  component={m.span}
                  color="rgba(255,255,255,0.9)"
                  fontFamily="Poppins"
                  fontSize={{ xs: 7.8, sm: 10, md: 11.5, lg: 13 }}
                  sx={{ textShadow: '0 2px 8px rgba(0,0,0,0.35)' }}
                >
                  Président du Conseil
                </Typography>
              </Stack>
            </Box>
          </HeroOverlayTextStyle>
        </RootStyle>
      </MotionContainer>
    </Box>
  );
}
